var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { combine } from 'zustand/middleware';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState) { return ({
        prepareChatsListRefresh: function () { return setState(function (state) { return (__assign(__assign({}, state), { currentPage: 0, loading: true, error: null })); }); },
        removeChat: function (chatId) {
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.filter(function (_a) {
                    var id = _a.id;
                    return id !== chatId;
                }), total: Math.max(0, state.total - 1) })); });
        },
        renameChat: function (_a) {
            var chatId = _a.chatId, title = _a.title;
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.map(function (chat) { return (chat.id === chatId ? __assign(__assign({}, chat), { title: title }) : chat); }) })); });
        },
        updateChatParams: function (_a) {
            var chatId = _a.chatId, title = _a.title, description = _a.description;
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.map(function (chat) {
                    return chat.id === chatId ? __assign(__assign(__assign({}, chat), { title: title }), (chat.type === 'groupChat' ? { description: description } : {})) : chat;
                }) })); });
        },
        updateChatLastMessage: function (_a) {
            var chatId = _a.chatId, message = _a.message, incrementUnread = _a.incrementUnread;
            return setState(function (state) {
                var chat = state.content.find(function (_a) {
                    var id = _a.id;
                    return id === chatId;
                });
                if (!chat)
                    return state;
                var updatedChat = __assign(__assign({}, chat), { lastMessage: message, unreadCount: incrementUnread ? chat.unreadCount + 1 : chat.unreadCount });
                return __assign(__assign({}, state), { content: __spreadArray([updatedChat], state.content.filter(function (_a) {
                        var id = _a.id;
                        return id !== chatId;
                    }), true) });
            });
        },
        editChatLastMessage: function (_a) {
            var chatId = _a.chatId, message = _a.message;
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.map(function (chat) { var _a; return chat.id === chatId && ((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.id) === message.id ? __assign(__assign({}, chat), { lastMessage: message }) : chat; }) })); });
        },
        markChatAsRead: function (chatId) {
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.map(function (chat) { return (chat.id === chatId ? __assign(__assign({}, chat), { unreadCount: 0 }) : chat); }) })); });
        },
    }); });
};
